export default __webpack_public_path__ + "media/images/dashboard_icons/user-0da9af0e122c1fd108d955ca5a07b3e8.svg";